import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDotNetComponent } from './simple-icons-dot-net.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDotNetComponent ],
    exports:      [ SimpleIconsDotNetComponent ],
    bootstrap:    []
})
export class SimpleIconsDotNetModule {}
